module.exports = "/img/recorder.f23c04dd.png";